import { BulletinBoardService } from './BulletinBoardService';

export function initBulletinBoard() {

  let element = document.getElementsByClassName("bulletinboard-enabled")[0] as HTMLElement;

  if (typeof (element) != 'undefined' && element != null) {

    BulletinBoardService.getMessages(element);

    const messageBtn = element.getElementsByClassName("btn-message")[0];

    messageBtn.addEventListener('click', (event) => {
      event.preventDefault();

      const message = {
        message: (document.getElementById("Message-" + element.dataset.widgetid) as HTMLInputElement).value,
        title: (document.getElementById("Title-" + element.dataset.widgetid) as HTMLInputElement).value,
        pageUrl: (document.getElementById("PageUrl-" + element.dataset.widgetid) as HTMLInputElement).value
      };

      BulletinBoardService.PostMessage(message);

    });

    const msgArea = element.querySelectorAll("textarea")[0];
    const counter =  document.getElementById("the-message-counter-" + element.dataset.widgetid) as HTMLElement;
    const current = counter.getElementsByClassName("current")[0] as HTMLElement;

    msgArea.addEventListener('keyup', (event) => {

      let characterCount = (event.target as HTMLTextAreaElement).value.length;
      current.innerHTML = characterCount.toString();

    });
  
    const titleInput = document.getElementById("Title-" + element.dataset.widgetid) as HTMLInputElement;
    const titleCounter =  document.getElementById("the-title-counter-" + element.dataset.widgetid) as HTMLElement;
    const titleCurrent = titleCounter.getElementsByClassName("current")[0] as HTMLElement;

    titleInput.addEventListener('keyup', (event) => {

      let characterCount = (event.target as HTMLInputElement).value.length;
      titleCurrent.innerHTML = characterCount.toString();

    });
  }

}